import { BRANDING_LAUNCHER_VISIBILITY } from "@apps/rewards/modules/StorefrontValues/constants";
import type { BrandingLauncherVisibilityType } from "@apps/rewards/modules/StorefrontValues/types";

/**
 * Determines if the pop up widget launcher should be visible based on the visibility settings.
 *
 * @param {BRANDING_LAUNCHER_VISIBILITY} launcherVisibility - The visibility setting for the launcher.
 * @returns True if the launcher should be visible, false otherwise.
 */
export const isPopUpWidgetLauncherVisible = (
    launcherVisibility: BrandingLauncherVisibilityType
): boolean => {
    const isDesktop = window.innerWidth >= 1024;

    const isVisible =
        launcherVisibility === BRANDING_LAUNCHER_VISIBILITY.allDevices;
    const isVisibleOnDesktop =
        launcherVisibility === BRANDING_LAUNCHER_VISIBILITY.desktopOnly;

    return isVisible || (isVisibleOnDesktop && isDesktop);
};
